import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrlHelper } from '../api-url-helper';
import { HttpClientHelper } from '../http-helper';
import { map } from 'rxjs/operators';

@Injectable()
export class BlacklistService {
    constructor(
        private _apiUrlHelper: ApiUrlHelper,
        private _httpClientHelper: HttpClientHelper,
    ) { }

    getBlacklist(params: any) {
        // console.log(params);
        const p = {
            orderBy: params.orderBy,
            page: params.page,
            size: params.size,
            tags: params.tag
        }
        const tempParams = { ...p };
        const apiURL = this._apiUrlHelper.urlBuilder('blacklist', tempParams);
        return this._httpClientHelper.get(apiURL)
            .pipe(
                map(res => {
                    return res[0];
                }));
    }

    addBlacklist(params: any) {
        const tempParams = { ...params };
        const apiURL = this._apiUrlHelper.urlBuilder('addblacklist', tempParams);
        return this._httpClientHelper.get(apiURL);
    }

    removeBlacklist(params: any) {
        const tempParams = { ...params };
        const apiURL = this._apiUrlHelper.urlBuilder('removeblacklist', tempParams);

        return this._httpClientHelper.get(apiURL);
    }
}
